// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

// Import and register all your controllers from the importmap under controllers/*
import { application } from "./application";

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import StatusFilterController from "./status_filter_controller";
application.register("status-filter", StatusFilterController);

import AlertController from "./alert_controller";
application.register("alert", AlertController);

import LengthToggleController from "./length_toggle_controller";
application.register("length-toggle", LengthToggleController);

import EnablesToggleController from "./col_def_enables_controller";
application.register("enables", EnablesToggleController);

import ForeignKeyTableController from "./foreign_key_table_controller";
application.register("foreign-key-table", ForeignKeyTableController);

import HideUnHideController from "./hide_unhide_controller";
application.register("hide-unhide", HideUnHideController);

import ToggleHiddenController from "./toggle_hidden_controller";
application.register("toggle-hidden", ToggleHiddenController);

import { RailsuiTooltip } from 'railsui-stimulus'
application.register('railsui-tooltip', RailsuiTooltip)

import SidebarController from "./sidebar_controller";
application.register("sidebar", SidebarController);

import TableNameController from "./table_name_controller";
application.register("table-name", TableNameController);

import ReorderController from "./reorder_controller"
application.register("reorder", ReorderController)

import "./railsui"

// Import and register AG Grid controller
import AgGridController from "./ag_grid_controller"
application.register("ag-grid", AgGridController)


// Promotions grid controllers
import GridController from "./grid_controller";
application.register("grid", GridController);

import FilterPopoverController from "./filter_popover_controller";
application.register("filter-popover", FilterPopoverController);


import LocalTimeController from "./local_time_controller";
application.register("local-time", LocalTimeController);

import ModalController from "./modal_controller";
application.register("modal", ModalController);

import ModalLauncherController from "./modal_launcher_controller";
application.register("modal-launcher", ModalLauncherController);

import BranchFormController from "./branch_form_controller";
application.register("branch-form", BranchFormController);

import EnvironmentFormController from "./environment_form_controller";
application.register("environment-form", EnvironmentFormController);

import FillViewportController from "./fill_viewport_controller";
application.register("fill-viewport", FillViewportController);

// Column Definitions AG Grid controller
import ColumnDefinitionsGridController from "./column_definitions_grid_controller";
application.register("column-definitions-grid", ColumnDefinitionsGridController);

// Table Definition Clone dialog controller
import TableCloneController from "./table_clone_controller";
application.register("table-clone", TableCloneController);

// Promotion Table Definition toggle controller
import PromotionTableDefinitionToggleController from "./promotion_table_definition_toggle_controller";
application.register("ptd-toggle", PromotionTableDefinitionToggleController);

// Promotion Table Definition restore controller
import PromotionTableDefinitionRestoreController from "./ptd_restore_controller";
application.register("ptd-restore", PromotionTableDefinitionRestoreController);

// Hierarchical menu controller
import HierarchicalMenuController from "./hierarchical_menu_controller";
application.register("hierarchical-menu", HierarchicalMenuController);

// Clipboard controller
import ClipboardController from "./clipboard_controller";
application.register("clipboard", ClipboardController);

// S3 Upload controllers
import S3UploadController from "./s3_upload_controller";
application.register("s3-upload", S3UploadController);

import ImportSchemaUploadController from "./import_schema_upload_controller";
application.register("import-schema-upload", ImportSchemaUploadController);

import QuickStartUploadController from "./quick_start_upload_controller";
application.register("quick-start-upload", QuickStartUploadController);

import QuickStartProgressController from "./quick_start_progress_controller";
application.register("quick-start-progress", QuickStartProgressController);

import FilePreviewController from "./file_preview_controller";
application.register("file-preview", FilePreviewController);

import ManualImportController from "./manual_import_controller";
application.register("manual-import", ManualImportController);

import ImportMappingController from "./import_mapping_controller";
application.register("import-mapping", ImportMappingController);

import ManualExportController from "./manual_export_controller";
application.register("manual-export", ManualExportController);

import DashboardSearchController from "./dashboard_search_controller";
application.register("dashboard-search", DashboardSearchController);

import SidebarResizeController from "./sidebar_resize_controller";
application.register("sidebar-resize", SidebarResizeController);
